import type { TGamesLocale } from '../games.types';

export const games = {
  'red-light-green-light': {
    name: 'Red light\ngreen light',
    description:
      'Reach the goal while the guard watches. Move only on green; freeze on red or you are eliminated. Last player standing wins.',
    rules: '',
  },
  'chinese-game-go': {
    name: 'chinese\ngame go',
    description:
      'Classic territorial strategy on a 19×19 board. Surround territory and capture stones to win.',
    rules: '',
  },
  'tic-tac-toe': {
    name: '5×5\nTic-Tac-Toe',
    description:
      'A fresh take on a classic: play on a 5×5 grid and connect four in a row. Fast rounds and sharp tactics.',
    rules:
      'Players take turns placing X or O on a 5×5 grid. The first to get four in a row (horizontally, vertically, or diagonally) wins. If the grid fills with no winner, the game is a draw.',
  },
  'classic-chess': {
    name: 'classic\nChess',
    description:
      'Standard chess with ranked stakes and timed games. Win by checkmate or on time to take the pot.',
    rules:
      'Standard chess. White moves first. 5 minutes per player, no increment. Win by checkmate or when the opponent runs out of time.',
  },
  'four-in-a-row': {
    name: 'Four in a row',
    description:
      'Drop discs into a 7×6 grid and connect four in a row before your opponent. Simple rules, deep counterplay.',
    rules:
      'Drop tokens from the top into a 7×6 grid. Take turns with your opponent. The first to get four of your tokens in a row (horizontally, vertically, or diagonally) wins. If the board fills with no winner, the game is a draw.',
  },
  battleship: {
    name: 'Battleship',
    description: 'Classic Battleship: 10×10, sink all opponent ships.',
    rules:
      'Classic Battleship: 10×10 grid, 10 ships (1×4, 2×3, 3×2, 4×1). Take turns shooting at the opponent grid. First to sink all opponent ships wins.',
  },
} satisfies TGamesLocale;
